import { Card } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";

interface RangeData {
  range: string;
  count: number;
  percentage: number;
}

interface PopularRangesProps {
  ranges: RangeData[];
}

export const PopularRanges = ({ ranges }: PopularRangesProps) => {
  return (
    <Card className="p-6">
      <h3 className="text-xl font-bold text-foreground mb-4">Most Popular Ranges</h3>
      <div className="space-y-4">
        {ranges.map((range) => (
          <div key={range.range}>
            <div className="flex justify-between items-center mb-2">
              <span className="text-sm font-medium text-foreground">{range.range}</span>
              <span className="text-sm text-muted-foreground">{range.count} generations</span>
            </div>
            <Progress value={range.percentage} className="h-2" />
          </div>
        ))}
        {ranges.length === 0 && (
          <p className="text-sm text-muted-foreground text-center py-4">No data available yet</p>
        )}
      </div>
    </Card>
  );
};
